<template>
  <div>
    <v-bottom-sheet v-model="notesShowing">
      <template slot="activator">
        <v-btn fab :small="small" color="primary"
          :class="unfixed ? '' : 'internal-notes-button-fixed'"
          :loading="gettingNotes"
        >
          <div v-if="internalNotes && internalNotes.length > 0">
            <v-badge
              color="grey"
              right
            >
              <template slot="badge">
                <span>{{ internalNotes.length }}</span>
              </template>
              <v-icon>
                notes
              </v-icon>
            </v-badge>
          </div>
          <div v-else>
              <v-icon>
              notes
            </v-icon>
          </div>
        </v-btn>
      </template>
      <v-sheet height="500" class="pa-4" >
        <v-layout column style="height: 100%;">
          <v-layout row shrink>
            <v-flex>
              <h2 class="heading">Internal Notes</h2>
            </v-flex>
            <!-- START - Search input -->
            <v-flex shrink>
              <v-text-field 
                type="text" 
                v-model="search" 
                placeholder="Search notes.."
                clearable
                append-icon="search"
              >
                Search Notes
              </v-text-field>
            </v-flex>
            <!-- END -->
          </v-layout>

          <div v-if="!search">
            <v-layout row shrink>
              <v-textarea
                rows="1"
                label="New note..."
                v-model="newNoteText"
              ></v-textarea>
              <v-btn icon color="success" :disabled="addingNote || !newNoteText" :loading="addingNote" @click="addNote">
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>
            <v-layout row wrap shrink justify-start align-content-start>
              <v-flex v-if="copyToEmployeeId">
                <v-checkbox
                  class="mt-0"
                  label="Copy note to Employee"
                  v-model="copyToEmployee"
                >
                </v-checkbox>
              </v-flex>
              <v-flex v-if="copyToLocationId">
                <v-checkbox
                  class="mt-0"
                  label="Copy note to Location"
                  v-model="copyToLocation"
                >
                </v-checkbox>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>
          </div>

          <v-divider class="mb-4"></v-divider>

          <!-- START - Show notes filtered by search term -->
          <v-layout v-if="search" column style="overflow-y: scroll;">
            <v-flex>
              <h3>Search results: <span v-if="filteredList.length == 0"> no notes found with that search term.</span></h3>
            </v-flex>
            <v-flex v-for="note in filteredList">
              <v-layout column>
                <v-flex>
                  <p class="body mb-0">
                    {{ note.text }}
                  </p>
                </v-flex>
                <v-flex>
                  <span class="subtle">
                    - {{ note.authorName }}, {{ note.createdAt | moment('MMMM DD YYYY, H:mma') }}
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- END -->

          <!-- START - Show all notes, but not if a search term is entered -->
          <v-layout v-if="!search" column style="overflow-y: scroll;">
            <v-flex>
              <h3>All notes: </h3>
            </v-flex>
            <v-flex v-for="note in notesSorted">
              <v-layout column>
                <v-flex>
                  <p class="body mb-0">
                    {{ note.text }}
                  </p>
                </v-flex>
                <v-flex>
                  <span class="subtle">
                    - {{ note.authorName }}, {{ note.createdAt | moment('MMMM DD YYYY, H:mma') }}
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- END -->

        </v-layout>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import internalNotesApi from '@/api/internal-notes'

export default {
  name: 'InternalNotesWidget',
  props: [
    'entityName', 'entityId', 'copyToEmployeeId', 'copyToLocationId', 'unfixed', 'small'
  ],
  created () {
    this.setUp()
  },
  computed: {
    notesSorted: function () {
      return this.internalNotes.slice().sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt))
    },
    filteredList() {
      return this.internalNotes.filter(post => {
        return post.text.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    setUp: function () {
      this.getNotes()
    },
    getNotes: function () {
      this.gettingNotes = true
      internalNotesApi.getForEntity({
        entityName: this.entityName,
        entityId: this.entityId
      },
      notes => {
        this.internalNotes = notes
        this.gettingNotes = false
      },
      error => {
        console.log('error getting internal notes')
        this.gettingNotes = false
      })
    },
    addNote: function () {
      this.addingNote = true
      let noteText = this.newNoteText

      internalNotesApi.create({
        entityName: this.entityName,
        entityId: this.entityId,
        text: this.newNoteText,
      },
      note => {
        this.internalNotes.push(note)
        this.addingNote = false
        this.newNoteText = ""
      },
      error => {
        console.log('error creating internal note')
        this.addingNote = false
      })

      if (this.copyToEmployee) {
        let entityName = 'User'
        let entityId = this.copyToEmployeeId
        internalNotesApi.create({
          entityName: entityName,
          entityId: entityId,
          text: noteText,
        },
        note => {
          this.copyToEmployee = false
        },
        error => {
          console.log('error creating internal note')
          this.copyToEmployee = false
        })
      }

      if (this.copyToLocation) {
        let entityName = 'Worksite'
        let entityId = this.copyToLocationId
        internalNotesApi.create({
          entityName: entityName,
          entityId: entityId,
          text: noteText,
        },
        note => {
          this.copyToLocation = false
        },
        error => {
          console.log('error creating internal note')
          this.copyToLocation = false
        })
      }
    },
  },
  data: function() {
    return {
      notesShowing: false,
      internalNotes: [],
      newNoteText: '',
      gettingNotes: false,
      addingNote: false,
      copyToEmployee: false,
      copyToLocation: false,
      search: '',
    }
  }
}
</script>

<style scoped>
.internal-notes-button-fixed {
  position: fixed;
  bottom: 5px;
  right: 5px;
  z-index: 1000;
}
</style>
